import React from "react";
import ABCarousel from "../ABCarousel";
import PreviewCarousel from "./PreviewCarousel";
const UploadPreviewUAN = React.forwardRef((props, ref) => {
  const { showModalBox, title, description, isAdd, image,sliderData,record,formData,allDocumentID,selectedId,previewArr,handleSingleDocDelete } = props;

  const closePopupHandler = () => {
    props.closePopup();
  };

//   const proceedHandler = (e) => {
//     e.preventDefault();
//     props.proceedHandler();
//   };
console.log(sliderData)

  return (
    <>
      <>
        {/* <div
          className={
            "cstm-popup-dialog " + (showModalBox === 1 ? "show" : "hidden")
          }
          onClick={closePopupHandler}
        >
          <div
            className="cstm-popup"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="cstm-popup-header">
              <h6 className="m-0">{title}</h6>
              <span
                className="cstm-popup-close-btn"
                onClick={closePopupHandler}
              >
                &times;
              </span>
            </div>
            <div className="cstm-popup-body p-3">
              <div className="d-flex flex-column align-items-center">
                <img
                  src={image}
                  className="img-fluid"
                  style={{ height: "300px" }}
                />
              </div>
            </div>
          </div>
        </div> */}
          <div
        className={
          "cstm-popup-dialog " + (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={closePopupHandler}
      >
        
        <div
          className="cstm-popup"
          onClick={(e) => {
            // do not close modal if anything inside modal content is clicked
            e.stopPropagation();
          }}
        >
          <div className="cstm-popup-header">
            <h6 className="m-0">{title}</h6>
            <span className="cstm-popup-close-btn" onClick={closePopupHandler}>
              &times;
            </span>
          </div>
          <div className="cstm-popup-body p-3">

          {/* {isLoading && <LoaderOnlySpinner /> } */}

          {previewArr.length > 0 ? (
            
          <PreviewCarousel 
          // items={sliderData} 
          items={previewArr}
          record={record} 
          selectedId={selectedId} 
          allDocumentID={allDocumentID} 
          formData={formData} 
          previewArr={previewArr} 
          handleSingleDocDelete={handleSingleDocDelete}
          reRenderAgain={props?.reRender}/>
          ) : (
            <>
              {/* <center>No item found</center> */}
            </>
          )}
            </div>
        </div>
      </div>
      </>
    </>
  );
});

export default UploadPreviewUAN;
